<template>
    <img
        :src="`/icons/${icon}.svg`"
        :alt="`icon-${icon}`"
        :style="iconStyle"
        :class="className"
        :width="width"
        :height="height"
    >
</template>

<script>
    export default {
        name: 'Icon',
        props: {
            icon: {
                type: String
            },
            iconStyle: {
                type: Object,
            },
            className: {
                type: String
            },
            width: {
                type: String,
                default: 'auto'
            },
            height: {
                type: String,
                default: 'auto'
            }
        }
    }
</script>